<template>
  <notifications
    :group="group"
    :duration="group === 'auth' ? 3000 : 5000"
    v-bind="$attrs"
    v-on="$listeners"
    :class="[
      'indexer',
      'w-full',
      'lg:w-1/3',
      'xl:w-1/4',
      group === 'auth' ? 'notificationcenter' : 'lg:max-w-md',
    ]"
  >
    <template slot="body" slot-scope="props">
      <div :class="['vue-notification w-full m-0 lg:m-1', props.item.type]">
        {{ props.item.title }}

        <div class="flex items-start w-full overflow-x-hidden">
          <div class="icon_wrapper">
            <BaseIcon :icon="icon(props.item.type)" class="text-lg" />
          </div>
          <div
            class="notification_text"
            v-html="
              $t(`mygwf.components.Notification.${group}.${props.item.type}.${props.item.text}`)
            "
          ></div>
        </div>
        <BaseIcon @click="props.close" icon="close" class="close_icon" />
      </div>
    </template>
  </notifications>
</template>

<script>
import BaseIcon from './_base-icon.vue'

export default {
  components: {
    BaseIcon,
  },
  props: {
    group: {
      type: String,
      default: 'app',
    },
  },
  methods: {
    icon(type) {
      switch (type) {
        case 'success':
          return 'success'
        case 'error':
          return 'info'
        case 'warn':
          return 'warn'
        default:
          return 'info'
      }
    },
  },
}
</script>

<style>
.indexer {
  z-index: 9000 !important;
}
.notificationcenter {
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0);
}

.vue-notification-group {
  @apply flex !important;
}

.vue-notification-group > span {
  @apply w-full !important;
}

.vue-notification-wrapper {
  @apply flex mx-auto !important;
}

.app .vue-notification-wrapper {
  @apply justify-center;
}

.auth .vue-notification-wrapper {
  @apply justify-center;
}

.icon_wrapper {
  @apply flex !important;

  background: rgba(0, 0, 0, 0.1);
  padding: 0.3rem;
}

.close_icon {
  @apply cursor-pointer flex leading-none rounded-full text-lg p-1 transition duration-200 !important;
}

.close_icon:hover {
  background: rgba(0, 0, 0, 0.1);
}

.vue-notification {
  @apply text-base border-0 py-2 px-3 relative flex items-start justify-between !important;
}

.notification_text {
  @apply leading-snug pl-3 pr-6 !important;

  margin-top: 0.075rem;
}

.vue-notification.warn {
  @apply bg-orange-default border-orange-dark !important;
}

.vue-notification.info {
  @apply bg-blue-default border-blue-dark !important;
}

.vue-notification.error {
  @apply bg-red-default border-red-dark !important;
}

.vue-notification.success {
  @apply bg-green-default border-green-dark !important;
}
</style>
